<template>
  <div class="this-unauthorized">
    Unauthorized works
  </div>
</template>

<script>
export default {
  name: 'Unauthorized',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-unauthorized {
  }
</style>
